import { combineReducers } from 'redux';
import Theme from './Theme';
import Account from './Account';
import User from './User';
import Clients from './Clients';
import ClientStatuses from './ClientStatuses';
import LeadSources from './LeadSources';
import Employees from './Employees';
import Quotes from './Quotes';
import Requests from './Requests';
import Jobs from './Jobs';
import Invoices from './Invoices';
import Loader from './Loader'

const reducers = combineReducers({
  theme: Theme,
  account: Account,
  user: User,
  clients: Clients,
  client_statuses: ClientStatuses,
  lead_sources: LeadSources,
  employees: Employees,
  loader: Loader,
  quotes: Quotes,
  requests: Requests,
  jobs: Jobs,
  invoices: Invoices,
});

export default reducers;